var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
document.addEventListener("DOMContentLoaded", () => {
  const waiting = document.querySelector(".waiting-room");
  if (!waiting) {
    return;
  }
  const dataUrl = waiting.dataset.url;
  if (!dataUrl) {
    return;
  }
  const checkStatus = () => __async(null, null, function* () {
    const response = yield fetch(dataUrl, {
      method: "GET",
      headers: {
        "Accept": "application/json",
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest"
      }
    });
    if (response.ok) {
      const result = yield response.json();
      if (result.url) {
        console.log("Redirecting to:", result.url);
        window.location.href = result.url;
      } else {
        setTimeout(checkStatus, 1e3);
      }
    }
  });
  setTimeout(checkStatus, 1e3);
});
